import React, { Component, useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import styles from "./styles/SellerInfo.scss";
import { getImageLink, getIconUrl } from "../../../services/asset";
import { formatDate, checkEmptyObject } from "../../../services";
import { ButtonType, PageRoute, ImageSizeEnum } from "../../../models";
import { formatLocationAddress } from "../../../routes/Configuration/helpers";
import ReactGA from "react-ga4";
import { selectCategories } from "../../App/selectors";
import FeatureFlags from "../../../featureFlags";
import { EntityType } from "../../../models/enums";
import useHrPageName from "../../../utils/useHrPageName";
import RatingButton from "../../../components/RatingButton";
import RatingCounter from "../../../components/RatingCounter";
import { IndexAvatar } from "../../../components";

// Seller address from the location names the API returns with the seller
// (city, county - or the country name for foreign sellers)
export const constructAddress = adCreator =>
  adCreator ? formatLocationAddress(adCreator) : null;

function SellerInfo({
  adCreator,
  category,
  position,
  adId
}) {
  const hrPageName = useHrPageName(category);
  const [imgError, setImgError] = useState(false);

  if (!adCreator) {
    return null;
  }

  const ratingsUrl = `${PageRoute.user}/${encodeURIComponent(adCreator.username)}${PageRoute.userRatings}`;
  const userAdsUrl = `${PageRoute.user}/${encodeURIComponent(adCreator.username)}`;

  return (
    <div>
      {/* Header row: Avatar + Username/Rating/SellerLink + Chevron */}
      <Link to={ratingsUrl} className={styles.headerRow}>
        <IndexAvatar
          size={67}
          url={adCreator.avatar}
          className={styles.avatar}
        />
        <div className={styles.headerContent}>
          <div className={styles.username}>
            {adCreator.username}
          </div>
          {checkEmptyObject(adCreator) && (
            <RatingCounter user={adCreator} />
          )}
          <Link
            to={userAdsUrl}
            className={styles.sellerLink}
            onClick={(e) => {
              e.stopPropagation()
              ReactGA.event({
                category: "Detalji oglasa",
                action: "Click",
                label: `Pogledaj sve oglase oglašivača (avatar) - ${hrPageName}`
              });
            }}
          >
            Svi oglasi oglašivača
          </Link>
        </div>
        <img src={getIconUrl("chevron-right.svg")} alt="" className={styles.chevron} />
      </Link>

      {/* Rate button */}
      {checkEmptyObject(adCreator) && (
        <div className={styles.ratingButtonWrapper}>
          <RatingButton
            user={adCreator}
            adId={adId}
            gaLabel="Ocijeni - iz oglasa"
          />
        </div>
      )}

      <div className={styles.info}>
        {adCreator && adCreator.legalEntity === EntityType.LegalEntity && (
          <div>{constructAddress(adCreator)}</div>
        )}
        <div>{`${"Registriran"} ${formatDate(
          adCreator.registrationDate
        )}`}</div>
        <div>


          {
            adCreator && (
              adCreator &&
                adCreator.legalEntity === EntityType.LegalEntity &&
                FeatureFlags.SHOW_LEGAL_ENTITY
                ? `${"Pravna osoba"}`
                : `${"Fizička osoba"}`
            )
          }
        </div>
      </div>

      <div className={styles.space}></div>
    </div>
  );
}

export default connect(
  state => ({
    categories: selectCategories(state)
  })
)(SellerInfo);



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageWeb/SellerInfo.tsx